import React from 'react';
import '../../styles/QuizScreen.css';
import '../../styles/NewLevelScreen.css';

export default function NewLevelScreen({
  title,
  text,
  image,
  levelInfo
}) {
  return (
    <div className="new-level-screen quiz-screen quiz-card">
      <div className="quiz-card new-level-card">

        {title && (
          <div
            className={`
              new-level-title
              font-${title?.fontSize ?? 'md'}
              text-${title?.textAlign ?? 'center'}
            `}
            dangerouslySetInnerHTML={{ __html: title.value }}
          />
        )}

        {text && (
          <div
            className={`
              new-level-text
              font-${text?.fontSize ?? 'md'}
              text-${text?.textAlign ?? 'center'}
            `}
            dangerouslySetInnerHTML={{ __html: text.value }}
          />
        )}

        {levelInfo && (
          <div className="new-level-info">
            <div className="new-level-header">
              <div className="new-level-number">
                Рівень {levelInfo.currentLevel}
              </div>

              <div className="level-status status-finished"><span className="level-status-text">Завершено</span></div>
            </div>


            <div className="new-level-info-image">
              <img src={levelInfo.levelImg} alt="" />
            </div>

            <div className="new-level-info-content">
              <div className="new-level-score">
                {levelInfo.scoreDisplay}
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
